// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__FeuST","row":"ProcedureTreatmentSummary_row__3EUpA"};